import { FC } from 'react'
import classNames from 'classnames'
import { IconMap, IconStripDash } from 'icons'
import { TQueryParams, TypedUrlQueries, getRouterProperties } from 'lib/search'
import Button from 'components/Button'
import styles from './ToggleView.module.scss'

export type TProps = {
  onClick: () => void
  queryVariables: TQueryParams
}

const ToggleView: FC<TProps> = ({ onClick, queryVariables }) => {
  const { isMap } = queryVariables

  const routeProps = getRouterProperties({
    ...queryVariables,
    isMap: !queryVariables.isMap,
  } as TypedUrlQueries)

  return (
    <Button
      element="a"
      href={`${routeProps.pathname}?${routeProps.search}`}
      className={classNames({
        [styles.ecToggleButtonMap]: isMap,
      })}
      Icon={{
        Component: isMap ? IconStripDash : IconMap,
        title: isMap ? 'Ir para a lista' : 'Ir para o mapa',
        color: 'grey900',
      }}
      aria-label={isMap ? 'Ir para a lista' : 'Ir para o mapa'}
      onClick={onClick}
    >
      {isMap ? 'Lista' : 'Mapa'}
    </Button>
  )
}

export default ToggleView
